import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Prefectures,
  CommonOrCommonRetirementFlug,
  DepositType,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP016_Request } from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  changeZipcodeFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import {
  funStatusBodyList,
  fundownloadBodyList,
} from "./../SCRW410005/hooks/useHooks";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_RET004 } from "./api/request";
import { fakeTableList, headList, schema } from "./parts";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import _ from "lodash";

/**
 * SCRW410005 退職手当金受領者の変更手続き（登録内容の確認）
 * @return SCRW410005 退職手当金受領者の変更手続き（登録内容の確認）
 */
const SCRW410005 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location?.state;
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { state: businessState } = useContext<any>(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [status, setStatus] = useState<any>();
  const [statusBodyList, setStatusBodyList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const [resRetirementStaffName, setResRetirementStaffName] = useState<any>("");
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("1");
  const applyId = locationState?.applyId ?? businessState?.job_41?.applyId;

  const handleInit = async () => {
    try {
      const res = await httpAPI_RET004({
        applyId: applyId,
        contractorNo: businessState?.common?.contractorNo,
      });

      let resArr = stateFakeTableListRef.current;

      setStatus(res.latestApplyStatus);
      setCorpApplyKbn(res.corpApplyKbn);
      setResRetirementStaffName(res.retirementStaffName);

      // 初期表示
      resArr.find((item) => item.keyword === "demanderNameKana")!.text =
        res.demanderNameKana;
      resArr.find((item) => item.keyword === "demanderName")!.text =
        res.demanderName;

      resArr.find((item) => item.keyword === "demanderBirth")!.text =
        res.demanderBirth;

      resArr.find((item) => item.keyword === "demanderZipcode")!.text =
        changeZipcodeFormat(res.demanderZipcode);

      if (
        res.demanderPrefectureCd !== undefined &&
        !isNaN(Number(res.demanderPrefectureCd))
      ) {
        resArr.find((item) => item.keyword === "locationGroup")!.text =
          (TkGetCode(Prefectures, res.demanderPrefectureCd) ?? "") +
          (res.demanderCity ?? "") +
          (res.demanderAddressOthers ?? "");
      }
      resArr.find((item) => item.keyword === "tel")!.text = res.tel;

      resArr.find((item) => item.keyword === "demanderEmail")!.text =
        res.demanderEmail;

      resArr.find((item) => item.keyword === "agentEmail")!.text =
        res.agentEmail;

      resArr.find((item) => item.keyword === "bankCd")!.text = res.bankCd;

      resArr.find((item) => item.keyword === "bankName")!.text = res.bankName;

      resArr.find((item) => item.keyword === "branchCd")!.text = res.branchCd;

      resArr.find((item) => item.keyword === "branchName")!.text =
        res.branchName;

      resArr.find((item) => item.keyword === "depositType")!.text = TkGetCode(
        DepositType,
        res.depositType
      );

      resArr.find((item) => item.keyword === "accountNo")!.text = res.accountNo;

      resArr.find((item) => item.keyword === "accountNameKana")!.text =
        res.accountNameKana;

      //「死亡診断書」又は「死体検案書」（写）
      let deathOrAutopsyReport = resArr.find(
        (item) => item.keyword === "deathOrAutopsyReport"
      )!;

      //職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）
      let yesLivelihoodInvestForm = resArr.find(
        (item) => item.keyword === "yesLivelihoodInvestForm"
      )!;

      //職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号
      let noLivelihoodInvestForm = resArr.find(
        (item) => item.keyword === "noLivelihoodInvestForm"
      )!;

      //内縁関係についての「生計維持に関する調査書」（様式１１号）
      let marriageReport = resArr.find(
        (item) => item.keyword === "marriageReport"
      )!;

      //職員の死亡を証する「戸籍謄本」又は「除籍謄本」
      let certifiedCertificateResidence = resArr.find(
        (item) => item.keyword === "certifiedCertificateResidence"
      )!;

      //その他、事実上の配偶者であることを証明する書類
      let claimantPartnerBook = resArr.find(
        (item) => item.keyword === "claimantPartnerBook"
      )!;

      //確認する書類の選択
      let identifyDocsKind = resArr.find(
        (item) => item.keyword === "identifyDocsKind"
      )!;
      identifyDocsKind.setDefaultValue = res.identificationDocsKind;

      //死亡した退職者の個人番号を確認する書類
      let deceasedRetireeNumCheckDoc = resArr.find(
        (item) => item.keyword === "deceasedRetireeNumCheckDoc"
      )!;

      //本人であることを確認するための書類
      let identityDocs = resArr.find(
        (item) => item.keyword === "identityDocs"
      )!;

      //本人であることを確認するための書類（表）
      let identityDocHead = resArr.find(
        (item) => item.keyword === "identityDocHead"
      )!;

      //本人であることを確認するための書類（裏）
      let identityDocTail = resArr.find(
        (item) => item.keyword === "identityDocTail"
      )!;

      //個人番号を確認する書類
      let numberCheckDoc = resArr.find(
        (item) => item.keyword === "numberCheckDoc"
      )!;

      //振込先口座が確認できる書類
      let payAccountCheckDoc = resArr.find(
        (item) => item.keyword === "payAccountCheckDoc"
      )!;

      if (
        res.identificationDocsKind === "2" ||
        res.identificationDocsKind === "4"
      ) {
        identityDocs.showLine = false;
        identityDocHead.showLine = true;
        identityDocTail.showLine = true;
      } else {
        identityDocs.showLine = true;
        identityDocHead.showLine = false;
        identityDocTail.showLine = false;
      }

      if (res.fileList) {
        res.fileList.forEach((file: any) => {
          if (file.formKbn !== "6") return; //帳票区分が"6"「退職書類」以外は何もしない
          switch (file.formClass) {
            case "14": //(「死亡診断書」又は「死体検案書」（写）)の場合
              deathOrAutopsyReport.showLine = true;
              deathOrAutopsyReport.base64filedata = file.file;
              deathOrAutopsyReport.dataname = file.formName;
              break;
            case "10": // (職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）)の場合
              if (res.demanderRelationship === "2") {
                marriageReport.showLine = true;
                marriageReport.base64filedata = file.file;
                marriageReport.dataname = file.formName;
              } else if (
                res.demanderRelationship === "3" ||
                res.demanderRelationship === "8"
              ) {
                if (res.livelihoodFromRetireeFlg === "1") {
                  yesLivelihoodInvestForm.showLine = true;
                  yesLivelihoodInvestForm.base64filedata = file.file;
                  yesLivelihoodInvestForm.dataname = file.formName;
                } else {
                  noLivelihoodInvestForm.showLine = true;
                  noLivelihoodInvestForm.base64filedata = file.file;
                  noLivelihoodInvestForm.dataname = file.formName;
                }
              }
              break;
            case "21": //(職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」)の場合
              certifiedCertificateResidence.showLine = true;
              certifiedCertificateResidence.base64filedata = file.file;
              certifiedCertificateResidence.dataname = file.formName;
              break;
            case "22": // (その他、事実上の配偶者であることを証明する書類)の場合
              claimantPartnerBook.showLine = true;
              claimantPartnerBook.base64filedata = file.file;
              claimantPartnerBook.dataname = file.formName;
              break;
            case "23":
              identityDocs.showLine = true;
              identityDocs.base64filedata = file.file;
              identityDocs.dataname = file.formName;
              break;
            case "24": // (本人確認書類（表面）)の場合
              identityDocHead.showLine = true;
              identityDocHead.base64filedata = file.file;
              identityDocHead.dataname = file.formName;
              break;
            case "25": // (本人確認書類（裏面）)の場合
              identityDocTail.showLine = true;
              identityDocTail.base64filedata = file.file;
              identityDocTail.dataname = file.formName;
              break;
            case "27": // (個人番号を確認する書類)の場合
              numberCheckDoc.showLine = true;
              numberCheckDoc.base64filedata = file.file;
              numberCheckDoc.dataname = file.formName;
              break;
            case "28": // (振込先口座が確認できる書類)の場合
              payAccountCheckDoc.showLine = true;
              payAccountCheckDoc.base64filedata = file.file;
              payAccountCheckDoc.dataname = file.formName;
              break;
            case "38": // (死亡した退職者の個人番号を確認する書類)の場合
              deceasedRetireeNumCheckDoc.showLine = true;
              deceasedRetireeNumCheckDoc.base64filedata = file.file;
              deceasedRetireeNumCheckDoc.dataname = file.formName;
              break;
          }
        });
      }

      const downloadBodyList = fundownloadBodyList(res);
      setBodyList(downloadBodyList);

      const statusList = funStatusBodyList(res.memoList);

      setStatusBodyList(statusList);
      setStateTableList([...resArr]);
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const data: IAPI_APP016_Request = {
      applyId: applyId,
      applyEvent: num,
      contractorNo: businessState?.common?.contractorNo,
      inquiryCode: memoCheck ? "3" : undefined,
      screenId: "SCRW410005",
      reason: memoData,
    };
    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData?.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }

    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : "";

    if (num === "") {
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  return (
    <Box className="SCRW410005" data-testid="SCRW410005PageForTest">
      <Box>
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-41"
          applicationStatus={status}
          corporateApplicationClassification={corpApplyKbn}
        />
      </Box>

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW410005_01}</TkInfoManual>
      <Box>
        {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
          <TkContractorAndNumberLine
            name="退職者名"
            no={resRetirementStaffName}
          />
        )}

        <TkFakeTable
          list={stateTableList}
          ruleSchema={schema}
          showButton={false}
        />

        <TkMemo
          bodyList={statusBodyList}
          showTable={true}
          onChange={onChange}
        />

        {isStatusAfterApproval(status) && (
          <TkTableWithNoLine headList={headList} bodyList={bodyList} />
        )}

        <Box className="btn">
          <TkBackButton className="tkBottonMr" />
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status}
            onClick={btnEvent}
          />
        </Box>

        <TkApprovalDateSymbolNumberRegistrationDialog
          data-testid="SCRW410005PageForDialog"
          open={isOpen}
          onSuccess={(e: any) => handleSave(e)}
          onClose={setOpen}
        />
      </Box>
    </Box>
  );
};

export default SCRW410005;
